import { IconButton } from "@chakra-ui/react";
import { Link as ReactLink } from "react-router-dom";

const NavLink = ({ children, route, onClick, state }) => (
  <IconButton as={ReactLink} px='2' py='1' rounded='md' variant='ghost' to={route} state={state} onClick={onClick}>
    {children}
  </IconButton>
);

export default NavLink;
